/**
 * Util function to get user locale
 *
 * @returns users locale if found in navigator, otherwise returns default locale.
 */
export const getUserLocale = () => {
    const { language, languages } = navigator;
    return language || languages[0];
};
